export default __webpack_public_path__ + "static/media/foremind-logo.bc154246.png";